<div class="p-3 h-full w-full">
  <router-outlet></router-outlet>
</div>
